document.addEventListener('DOMContentLoaded', function() {
  const productID = 41918196645971;
  const screenReaderInfo = document.getElementById('screen-reader-info');
  const upsellElement = document.getElementById('package-protection-upsell');
  const toggle = document.getElementById('add-package-protection-button');

  function announceToScreenReader(message) {
    if (screenReaderInfo) {
      screenReaderInfo.innerText = message;
      setTimeout(() => {
        screenReaderInfo.innerText = '';
      }, 1000);
    }
  }

  function addProductToCart(productID) {
    const cartData = {
      id: productID,
      quantity: 1
    };

    $.ajaxSetup({ cache: false });
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartData,
      dataType: 'json',
      success: function() {
        announceToScreenReader('Product was added to cart');
        localStorage.setItem('openCartDrawer', 'true');
        location.reload();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.error('Error adding product to cart:', textStatus, errorThrown);
      }
    });
  }

  // Check if the cart drawer should be opened on page load
  if (localStorage.getItem('openCartDrawer') === 'true') {
    localStorage.removeItem('openCartDrawer');
    const cartDrawer = document.getElementById('site-cart');
    if (cartDrawer) {
      cartDrawer.classList.add('style--sidebar', 'active');
      cartDrawer.setAttribute('tabindex', '-1');
      cartDrawer.setAttribute('role', 'dialog');
      cartDrawer.setAttribute('aria-modal', 'true');
      cartDrawer.style.display = 'block';
    }
  }

  // Use event delegation to handle button clicks
  document.body.addEventListener('click', function(event) {
    if (event.target.closest('#add-package-protection-button')) {
      addProductToCart(productID);
    }
  });
});
